var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardLinkSupportPunish(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.0392 3.9704C30.4541 0.399148 25.2993 0 19 0C12.6927 0 7.53007 0.40375 3.9465 3.98465C0.363448 7.56406 0 12.7184 0 19.0184C0 25.3195 0.363448 30.4754 3.94798 34.0561C7.53133 37.6375 12.6934 38 19 38C25.3066 38 30.4678 37.6375 34.0511 34.0561C37.6354 30.4748 37.9999 25.3195 37.9999 19.0184C37.9999 12.7103 37.6315 7.55041 34.0392 3.9704Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14L9 24C9 26.2091 10.7909 28 13 28H25C27.2091 28 29 26.2091 29 24V14M9 14C9 11.7909 10.7909 10 13 10L25 10C27.2091 10 29 11.7909 29 14M9 14L29 14M9 14L9.00009 18H29.0001L29 14M13.3376 24H13.3466",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLinkSupportPunish);
export default __webpack_public_path__ + "static/media/card_link_support_punish.e1cdc7af36589c27f3faaf86906cd6e2.svg";
export { ForwardRef as ReactComponent };